const configAggregator = (node) => {
    function getWidgetContentInnerHTML(node) {
        if (!node) return null

        const widgetNode = node.querySelector('[data-element="widget_content"]')
        return widgetNode ? widgetNode.innerHTML : null
    }

    return {
        backgroundColor: node.getAttribute('data-w-background-color'),
        topHeading: node.getAttribute('data-w-top-heading'),
        topHeadingColor: node.getAttribute('data-w-top-heading-color'),
        heading: node.getAttribute('data-w-heading'),
        headingColor: node.getAttribute('data-w-heading-color'),
        textElement: getWidgetContentInnerHTML(node)
    }
}

export default configAggregator
